<div class="row"></div>
<div class="row"></div>
<fieldset>
    <legend class="ams-legend-title">&nbsp;&nbsp;Data Migration&nbsp;&nbsp;</legend>
    <div class="card card-customize">
        <div class="card-block">
            <div class="row">
                <div class="col-md-4">
                    <kendo-upload id="file" [autoUpload]="false" [restrictions]="uploadRestrictions"
                        (select)="selectEventHandler($event)" (clear)="clearEventHandler($event)"
                        (remove)="removeEventHandler($event)" [multiple]="false"></kendo-upload>
                </div>
                <div class="mt-2">
                    <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'save'"
                        (click)="uploadMasterData()" [disabled]="!enableUploadButton">Upload</button>
                </div>
            </div>
        </div>
    </div>
</fieldset>

<div class="row"></div>
<div class="row"></div>
<fieldset>
    <legend class="ams-legend-title">&nbsp;&nbsp;Document Migration&nbsp;&nbsp;</legend>
    <div class="card card-customize">
        <div class="card-block">
            <div class="row">
                <div class="col-md-4">
                    <kendo-upload id="documentFile" [autoUpload]="false" [restrictions]="uploadRestrictions"
                        (select)="selectDocumentEventHandler($event)" (clear)="clearDocumentEventHandler($event)"
                        (remove)="removeDocumentEventHandler($event)" [multiple]="false"></kendo-upload>
                </div>
                <div class="mt-2">
                    <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'save'"
                        (click)="uploadDocumentData()" [disabled]="!enableDocumentUploadButton">Upload</button>
                </div>
            </div>
        </div>
    </div>
</fieldset>